module.exports = __webpack_public_path__ + "static/media/81c7nyvI0hL._AC_UX569_.13238dc4.jpg";